import { $generateHtmlFromNodes, $generateNodesFromDOM } from '@lexical/html'
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext'
import {
  $createParagraphNode,
  $createRangeSelection,
  $createTextNode,
  $getRoot,
  $setSelection,
  CLEAR_HISTORY_COMMAND,
} from 'lexical'
import { useEffect } from 'react'

export const SetValuePlugin: React.FC<{ value: string | undefined }> = ({ value = '' }) => {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    if (!!editor) {
      editor.update(
        () => {
          // pull content of editor
          const content = $generateHtmlFromNodes(editor, null)
          if (content !== value) {
            // if there are any differences, clear the control
            const root = $getRoot()

            const parser = new DOMParser()
            const dom = parser.parseFromString(value ?? '', 'text/html')
            const nodes = $generateNodesFromDOM(editor, dom)
            root.clear()
            if (nodes.length === 0) {
              const paragraph = $createParagraphNode()
              const textNode = $createTextNode('')
              paragraph.append(textNode)
              root.append(paragraph)
              const selection = $createRangeSelection()
              selection.anchor.set(textNode.getKey(), 0, 'text')
              selection.focus.set(textNode.getKey(), 0, 'text')
              $setSelection(selection)
            } else {
              // Resetting back to current value.
              const selection = root.select()
              selection.removeText()
              selection.insertNodes(nodes)
            }

            editor.dispatchCommand(CLEAR_HISTORY_COMMAND, undefined)
          }
        },
        { tag: 'skip-scroll-into-view' },
      )
    }
  }, [value, editor])

  return null
}
